import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgColorize = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "var(--main-color)",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "Colorize",
		clipPath: "url(#clip0_4309_44272)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L13.84 6.41L11.91 4.5L10.5 5.91L11.92 7.33L3 16.25V21H7.75L16.67 12.08L18.09 13.5L19.5 12.09L17.58 10.17L20.7 7.05C21.1 6.65 21.1 6.02 20.71 5.63ZM6.92 19L5 17.08L13.06 9.02L14.98 10.94L6.92 19Z",
			fillRule: "nonzero"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4309_44272",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "var(--main-color)"
		})
	}) })]
});
export { SvgColorize as ReactComponent };
